import { NgModule } from '@angular/core';
import { M2MRouterComponent } from './m2m-router.component';
import { M2MRouterDetailComponent } from './m2m-router-detail.component';
import { CxFormsModule } from '@forms';
import { M2MDataStore } from './m2m-data-store';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { M2MDeviceStateTranslationService, TranslateM2MDeviceStatePipe } from './m2m-device-state-translation.service';
import {
    M2MInformationItemNameTranslationService,
    TranslateM2MInformationItemNamePipe
} from './m2m-information-item-name-translation.service';
import { FormatM2MInformationItemValuePipe } from './format-m2m-information-item-value.pipe';
import { ExcludeInformationItemsPipe } from './exclude-information-items.pipe';

@NgModule({
    imports: [
        CxFormsModule,
        CommonModule,
        RouterModule
    ],
    declarations: [
        M2MRouterComponent,
        M2MRouterDetailComponent,
        TranslateM2MDeviceStatePipe,
        TranslateM2MInformationItemNamePipe,
        FormatM2MInformationItemValuePipe,
        ExcludeInformationItemsPipe
    ],
    exports: [
        M2MRouterComponent,
        M2MRouterDetailComponent,
        TranslateM2MDeviceStatePipe,
        TranslateM2MInformationItemNamePipe,
        FormatM2MInformationItemValuePipe,
        ExcludeInformationItemsPipe
    ],
    providers : [
        M2MDataStore,
        M2MDeviceStateTranslationService,
        TranslateM2MDeviceStatePipe,
        M2MInformationItemNameTranslationService,
        TranslateM2MInformationItemNamePipe,
        FormatM2MInformationItemValuePipe,
        ExcludeInformationItemsPipe
    ]
})
export class M2MRouterModule {}

export {
    M2MRouterComponent,
    M2MRouterDetailComponent,
    M2MDeviceStateTranslationService
};
